import { ICommand, IDatasource, IDefineCommand, IQuery, IQueryMediator, key } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APCourse } from '../builders/ap_course_builder';
import { APSectionType } from '../builders/ap_section_type_builder';
import { IAPCoursesDatasource } from '../datasources/ap_courses_datasource';
import { IAPMmFavoriteCoursesDatasource } from '../datasources/ap_mm_favorite_course_datasource';
import { IAPSectionTypeDatasource } from '../datasources/ap_section_type_datasource';
import { APCourseServant } from '../servants/ap_course_servant';

interface IFavoriteCourseAPI {
  section_type: Record<string, APSectionType>;
  course: Record<string, APCourse>;
}
interface IFavoriteCourse {
  id: number;
  cd: string;
  nk: string;
  title: string;
}

angular
  .module('capability-ng-academic-planner')
  .factory(
    'loadMmFavoriteCoursesCommand',
    (
      log: any,
      defineCommandORM: IDefineCommand,
      ngAPMmFavoriteCoursesDatasource: IAPMmFavoriteCoursesDatasource,
      $http: ng.IHttpService
    ): ICommand => {
      return defineCommandORM(
        'loadMmFavoriteCoursesCommand',
        function loadMmFavoriteCoursesCommand(deferred: ng.IDeferred<IQuery[]>): void {
          $http
            .get('/reg/favoritecourse/')
            .then((response: { data: IFavoriteCourseAPI }) => {
              const _favoriteCourse: IFavoriteCourse[] = _4.map(response.data.course, (course) => {
                return _4.pick(course, ['id', 'cd', 'nk', 'title']);
              });
              ngAPMmFavoriteCoursesDatasource.clear().write(_favoriteCourse);
              deferred.resolve();
            })
            .catch((e) => {
              log.issue('Failed to load favorite courses');
              deferred.reject(e.data);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/commands/load_mm_favorite_courses_command.ts